export default __webpack_public_path__ + "static/media/13.ca262936.png";